var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#213366"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6C7.67695 6 7.35391 6.12562 7.10932 6.3722L4.10037 9.40564C3.96654 9.54056 3.96654 9.76388 4.10037 9.89881C4.23421 10.0337 4.45573 10.0337 4.58956 9.89881L7.5985 6.86537C7.82002 6.64205 8.17998 6.64205 8.4015 6.86537L11.4104 9.89881C11.5443 10.0337 11.7658 10.0337 11.8996 9.89881C12.0335 9.76388 12.0335 9.54056 11.8996 9.40564L8.89068 6.3722C8.64609 6.12562 8.32305 6 8 6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableArrowUp);
export default __webpack_public_path__ + "static/media/table-arrow-up.be2e9b297e8efca0cf773427d4900cb7.svg";
export { ForwardRef as ReactComponent };